import React from 'react';
import { lazyload } from 'react-lazyload';
import { Link } from 'react-router-dom';
import { ItemList } from '../../components/item-list';
import { getCategoryLink } from '../../utils/category-utils';
import { getItemsInCategory } from '../../actions';
import { ISubscriptionState } from '../../reducers/subscription-reducers';
import { IKidsModeState } from '../../reducers/kids-mode-reducers';
import { IReduxProps } from '../../actions/action-types';
import { ICategory } from '../../reducers/category-reducers';

const imageHeight = 180;

export interface ICategoryProps extends IReduxProps {
	category: ICategory;
	subscription: ISubscriptionState;
	kidsMode: IKidsModeState;
}

@lazyload({
	height: imageHeight + 19,
	once: true,
	offset: 100,
	resize: true,
})
export class Category extends React.Component<ICategoryProps> {
	_renderItem(item, cover, coverEl) {
		return (
			<Link to={'/items/' + item.id} title={item.title}>
				{coverEl}
			</Link>
		);
	}

	_renderCategory(category, cover, coverEl) {
		return (
			<Link to={getCategoryLink(category)} title={category.title}>
				{coverEl}
			</Link>
		);
	}

	_getNextPage() {
		const {
			category: { nextPage, id },
			dispatch,
			kidsMode: { isKidsMode },
		} = this.props;
		dispatch(getItemsInCategory(id, nextPage, isKidsMode));
	}

	render() {
		const { category, kidsMode, subscription } = this.props;
		const isKidsMode = kidsMode && !!kidsMode.isKidsMode;
		const items = category.items || [];
		const subcategories = category.subcategories || [];

		if (!items.length && !subcategories.length) {
			return false;
		}
		const categoryUrl = getCategoryLink(category);

		return (
			<section className="category">
				<div className={`title-area${isKidsMode ? ' title-area-kids' : ''}`}>
					<Link className="title-link" to={categoryUrl}>
						<h4 className="title">{category.title}</h4>
					</Link>
				</div>
				<div className="slick-container">
					<ItemList
						items={items}
						categories={subcategories}
						pageToken={category.nextPage || null}
						imageHeight={imageHeight}
						renderItem={(item, cover, coverEl) => this._renderItem(item, cover, coverEl)}
						renderCategory={(category, cover, coverEl) => this._renderCategory(category, cover, coverEl)}
						getNextPage={() => this._getNextPage()}
						subscription={subscription}
						kidsMode={kidsMode}
					/>
				</div>
			</section>
		);
	}
}
